(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kenza-tax-document-fields"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kenza-tax-document')) {
    customElements.define('kenza-tax-document', class extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.fields = this.querySelector('[data-document-fields]');
        this.error = this.querySelector('[data-document-error]');
        this.nameLabel = this.querySelector('[data-name-label]');
        this.personLabel = this.nameLabel.textContent;
        this.invoiceOnly = this.querySelector('[data-invoice-only]');
        this.deliveryButton = this.querySelector('[data-use-delivery]');
        this.form = this.closest('form');
        this.saveTimer = null;

        this.querySelectorAll('input').forEach((input) => {
          input.addEventListener('input', () => this.scheduleSave());
          input.addEventListener('change', () => {
            this.updateFields();
            this.saveAttributes();
          });
        });

        this.deliveryButton.addEventListener('click', () => {
          const deliveryOption = this.querySelector('input[name="attributes[Documento tributario]"][value="BOLETA_ENTREGA"]');
          if (deliveryOption) deliveryOption.checked = true;
          this.updateFields();
          this.saveAttributes();
        });

        if (this.form) {
          this.form.addEventListener('submit', (event) => {
            if (event.submitter && event.submitter.name === 'checkout' && !this.validate()) {
              event.preventDefault();
              event.stopImmediatePropagation();
            }
          }, true);
        }

        this.updateFields();
      }

      get documentType() {
        return this.querySelector('input[name="attributes[Documento tributario]"]:checked')?.value || 'BOLETA_ENTREGA';
      }

      updateFields() {
        const type = this.documentType;
        const needsDetails = type !== 'BOLETA_ENTREGA';
        const isInvoice = type === 'FACTURA';
        this.fields.hidden = !needsDetails;
        this.invoiceOnly.hidden = !isInvoice;
        this.deliveryButton.hidden = !needsDetails;
        this.nameLabel.textContent = isInvoice ? this.dataset.companyNameLabel : this.personLabel;
        this.querySelectorAll('[data-required-document]').forEach((input) => { input.required = needsDetails; });
        this.querySelectorAll('[data-required-invoice]').forEach((input) => { input.required = isInvoice; });
        this.error.hidden = true;
      }

      validate() {
        this.updateFields();
        const invalid = [...this.querySelectorAll('input[required]')].find((input) => !input.checkValidity());
        if (!invalid) return true;
        this.details.open = true;
        this.error.hidden = false;
        invalid.reportValidity();
        invalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      }

      scheduleSave() {
        clearTimeout(this.saveTimer);
        this.saveTimer = setTimeout(() => this.saveAttributes(), 500);
      }

      async saveAttributes() {
        const attributes = {};
        this.querySelectorAll('input[name^="attributes["]').forEach((input) => {
          if (input.disabled) return;
          if (input.type === 'radio' && !input.checked) return;
          const match = input.name.match(/^attributes\[(.+)\]$/);
          if (match) attributes[match[1]] = input.value;
        });
        try {
          await fetch(this.dataset.updateUrl || '/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes }),
          });
        } catch (error) {
          console.warn('No se pudieron guardar los datos del documento.', error);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
